import { Component, OnInit } from '@angular/core';
import {
  IconEnum,
  ControlSizeEnum,
  ControlTypeColorEnum,
  AvatarTypeEnum,
  DialogRef
} from 'datnek-ds';

@Component({
  selector: 'del-shared-dialog-challenge-accept',
  templateUrl: './dialog-challenge-accept.component.html',
  styleUrls: ['./dialog-challenge-accept.component.scss'],
})
export class DialogChallengeAcceptComponent {
  iconEnum = IconEnum;
  sizeEnum = ControlSizeEnum;
  colorEnum = ControlTypeColorEnum;
  avatarEnum = AvatarTypeEnum;

  constructor(public ref: DialogRef) {}

  close() {
    this.ref.close();
  }
}
